import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import { deleteAllCalls } from "../../../services/CallsService";
import { deleteAllOrders } from "../../../services/OrdersService";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const TestIpact = () => {
  const { t } = useTranslation();
  const [deletingCalls, setDeletingCalls] = useState(false);
  const [deletingOrders, setDeletingOrders] = useState(false);

  const handleDeleteAllCalls = async () => {
    const confirmDelete = window.confirm(
      t("Are you sure you want to delete all calls? This action cannot be undone.") ||
      "Are you sure you want to delete all calls? This action cannot be undone."
    );

    if (!confirmDelete) {
      return;
    }

    setDeletingCalls(true);
    try {
      const response = await deleteAllCalls();
      toast.success(
        t("All calls deleted successfully") || 
        `All calls deleted successfully. ${response.deletedCount || 0} calls removed.`
      );
      
      // Notify SideBar to update badge count
      window.dispatchEvent(new CustomEvent("calls-count-updated", { detail: { pending: 0 } }));
    } catch (error) {
      console.error("Error deleting calls:", error);
      toast.error(
        error.response?.data?.message || 
        error.message || 
        t("Failed to delete calls") || 
        "Failed to delete calls"
      );
    } finally {
      setDeletingCalls(false);
    }
  };

  const handleDeleteAllOrders = async () => {
    const confirmDelete = window.confirm(
      t("Are you sure you want to delete all orders? This action cannot be undone.") ||
      "Are you sure you want to delete all orders? This action cannot be undone."
    );

    if (!confirmDelete) {
      return;
    }

    setDeletingOrders(true);
    try {
      const response = await deleteAllOrders();
      toast.success(
        t("All orders deleted successfully") || 
        `All orders deleted successfully. ${response.deletedCount || 0} orders removed.`
      );
    } catch (error) {
      console.error("Error deleting orders:", error);
      toast.error(
        error.response?.data?.message || 
        error.message || 
        t("Failed to delete orders") || 
        "Failed to delete orders"
      );
    } finally {
      setDeletingOrders(false);
    }
  };

  return (
    <>
      <PageTitle activeMenu="IPACT Test" motherMenu="Test" />
      <div className="row">
        <div className="col-12 col-md-6 mb-4">
          <Card>
            <Card.Header>
              <h4 className="card-title">Delete All Calls</h4>
            </Card.Header>
            <Card.Body>
              <div className="text-center py-5">
                <p className="mb-4" style={{ fontSize: "16px", color: "#666" }}>
                  {t("Click the button below to delete all calls for your restaurant.") ||
                    "Click the button below to delete all calls for your restaurant."}
                </p>
                <Button
                  variant="danger"
                  size="lg"
                  onClick={handleDeleteAllCalls}
                  disabled={deletingCalls}
                  style={{
                    backgroundColor: "#dc3545",
                    borderColor: "#dc3545",
                    fontSize: "16px",
                    padding: "12px 32px",
                    minWidth: "200px",
                  }}
                >
                  {deletingCalls ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {t("Deleting...") || "Deleting..."}
                    </>
                  ) : (
                    <>
                      <i className="fas fa-trash me-2"></i>
                      {t("Delete All Calls") || "Delete All Calls"}
                    </>
                  )}
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-12 col-md-6 mb-4">
          <Card>
            <Card.Header>
              <h4 className="card-title">Delete All Orders</h4>
            </Card.Header>
            <Card.Body>
              <div className="text-center py-5">
                <p className="mb-4" style={{ fontSize: "16px", color: "#666" }}>
                  {t("Click the button below to delete all orders for your restaurant.") ||
                    "Click the button below to delete all orders for your restaurant."}
                </p>
                <Button
                  variant="danger"
                  size="lg"
                  onClick={handleDeleteAllOrders}
                  disabled={deletingOrders}
                  style={{
                    backgroundColor: "#dc3545",
                    borderColor: "#dc3545",
                    fontSize: "16px",
                    padding: "12px 32px",
                    minWidth: "200px",
                  }}
                >
                  {deletingOrders ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {t("Deleting...") || "Deleting..."}
                    </>
                  ) : (
                    <>
                      <i className="fas fa-trash me-2"></i>
                      {t("Delete All Orders") || "Delete All Orders"}
                    </>
                  )}
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default TestIpact;

